import React from 'react'
import styled from '@emotion/styled'
import themeVars from 'ui_theme/site/globals/site.variables'

import NewConvoHeader from 'components/App/DesktopView/shared/NewConvoHeader'
import Composer from './Composer'

const FormContainer = styled('div')`
  height: 100%;
  padding-top: ${themeVars.massive};
  padding-left: ${props => props.theme.spacing['12']};
  padding-bottom: ${props => props.theme.spacing['6']};
  padding-right: ${props => props.theme.spacing['12']};
  background-color: ${props => props.theme.color.monochrome.white};
  overflow: auto;
`

export default function NewEmailPage() {
  return (
    <React.Fragment>
      <NewConvoHeader isLogging={false} />
      <FormContainer>
        <Composer />
      </FormContainer>
    </React.Fragment>
  )
}
